// extracted by mini-css-extract-plugin
export default {"sidebar":"ConfigurationSidebar_sidebar__j05sG","sidebar__wrapper":"ConfigurationSidebar_sidebar__wrapper__720DD","sidebar__support":"ConfigurationSidebar_sidebar__support__3rqD6"};